import { TEntityUntagged } from '@obvious.tech/constellation/Entity'
import { ColorArrayInput } from 'src/components/inputs/arrays/ColorArrayInput'
import { TEntityOverride } from 'src/types'

const override: TEntityOverride<TEntityUntagged<'AnalyticsConfiguration'>> = {
  global: {
    properties: {
      groups: {
        type: 'groups',
      },
      id: {
        displayedName: 'ID',
      },
      humanCategories: {
        displayedName: 'Human Categories',
        items: {
          properties: {
            imageId: {
              displayedName: 'Image',
              reference: {
                target: 'Image',
                targetLabelKeyPath: 'name',
              },
            },
            name: {
              displayedName: 'Name',
            },
            apparels: {
              displayedName: 'Apparels',
              items: {
                properties: {
                  name: {
                    displayedName: 'Name',
                  },
                  gender: {
                    displayedName: 'Gender',
                  },
                },
              },
            },
            colors: {
              displayedName: 'Colors',
              displayedComponent: ColorArrayInput,
            },
          },
        },
      },
      vehicleBrands: {
        displayedName: 'Vehicle Brands',
      },
      vehicleTypes: {
        displayedName: 'Vehicle Types',
      },
      vehicleColors: {
        displayedName: 'Vehicle Colors',
        displayedComponent: ColorArrayInput,
      },
    },
  },
  list: {
    properties: {
      humanCategories: {
        hidden: true,
      },
      vehicleColors: {
        hidden: true,
      },
    },
  },
}

export default override
